// Angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// CC-Common imports
import { IconConstants, Utils } from 'cc-common';

// Third party imports
import { DxFormComponent } from 'devextreme-angular';

// constant imports
import { Constants } from '../../../../../_constants/constants';

// Service imports
import { ServerErrorService } from '../../../../../_services/shared-services/server-error.service';
import { ARPaymentService } from '../../../_services/account-receivable/ar-payment.service';
import { HelperService } from '../../../../../_services/shared-services/helper.service';

// Model imports
import { ARPaymentParameterDto } from '../../../_models/account-receivable/ar-payment/ar-payment-parameter-dto';
import { ARPaymentResultDto } from '../../../_models/account-receivable/ar-payment/ar-payment-result-dto';
import { ARReversePaymentEditorResultDto } from '../../../_models/account-receivable/ar-payment/ar-reverse-payment-editor-result-dto';
import { ARReversePaymentRawDto } from '../../../_models/account-receivable/ar-payment/ar-reverse-payment-raw-dto';

@Component({
    selector: 'app-ar-payment-reverse-editor',
    templateUrl: './ar-payment-reverse-editor.component.html',
    styleUrls: ['./ar-payment-reverse-editor.component.scss']
})
export class ARPaymentReverseEditorComponent implements OnInit {
    @ViewChild('confirmForm', { static: false }) confirmForm: DxFormComponent;
    @Input() visible = false;
    @Input() arPaymentParam: ARPaymentParameterDto;
    @Input() arPaymentDetail: ARPaymentResultDto;
    @Output() onReverseEditorClose = new EventEmitter<boolean>();

    defaultLabelLocation: string = Constants.defaultFormLabelLocation;

    loadingVisible = false;
    reversePaymentEditorData: ARReversePaymentEditorResultDto;
    paymentInfo: ARReversePaymentRawDto;

    closeIcon: string = IconConstants.CLOSE;
    saveIcon: string = IconConstants.CHECK_MARK;

    showMiscInvoiceEditor = false;

    disableReverseButton = false;

    constructor(
        private readonly arPaymentService: ARPaymentService,
        private readonly errorService: ServerErrorService,
        private readonly helperService: HelperService
    ) {}

    ngOnInit() {
        if (Utils.notNullAndDefined(this.arPaymentParam)) {
            this.populateReverseEditor();
        }
    }

    onHidden(e): void {
        this.onReverseEditorClose.emit(false);
        this.visible = false;
    }

    onYesClick(): void {
        if (Utils.notNullAndDefined(this.confirmForm) && Utils.notNullAndDefined(this.confirmForm.instance)) {
            const validator = this.confirmForm.instance.validate();

            if (Utils.isTrue(validator.isValid)) {
                // Disable reverse action button
                this.disableReverseButton = true;

                // Show loading
                this.loadingVisible = true;

                this.arPaymentService.addARReversePayment(this.paymentInfo).subscribe(
                    () => {
                        const dialog = this.helperService.getConfirmationDialog(
                            'Confirmation',
                            '<b> The payment reversal has been successfully posted. Do you want to post an NSF charge or other charge on the account?</b>'
                        );

                        dialog.show().then((answer: boolean) => {
                            if (Utils.isTrue(answer)) {
                                this.postOtherCharge();
                            } else {
                                this.onHidden(null);
                            }
                        });

                        // Hide loading
                        this.loadingVisible = false;

                        // Enable reverse action button
                        this.disableReverseButton = true;
                    },
                    (error) => {
                        // Hide loading
                        this.loadingVisible = false;

                        // Display error
                        this.errorService.displayError(error);

                        // Enable reverse action button
                        this.disableReverseButton = true;
                    }
                );
            }
        }
    }

    postOtherCharge(): void {
        this.showMiscInvoiceEditor = true;
    }

    closeMiscInvoiceEditor(): void {
        this.showMiscInvoiceEditor = false;
        this.onHidden(null);
    }

    private populateReverseEditor(): void {
        this.loadingVisible = true;
        this.arPaymentService.getARReversePaymentEditor(this.arPaymentParam).subscribe(
            (result) => {
                this.reversePaymentEditorData = result;
                this.paymentInfo = result.paymentInfo;
                this.loadingVisible = false;
            },
            (error) => {
                this.loadingVisible = false;
                this.errorService.displayError(error);
                this.onHidden(false);
            }
        );
    }
}
